export const PARTIAL_FILE_PREFIX = '.zippycli.';

export const DEFAULT_TIMEOUT = 60;

export const DEFAULT_UPDATE_INTERVAL = 1000;
